export default "__VITE_ASSET__CjvT560J__"